//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'StatusBar',
  props: ['status'],
  data(){
        return {
        }
    },
  components: {
    
  }
}
